<template>
    <div class="card mb-3">
        <div class="card-header" v-show="showHeading">
            {{ translate('label.filters.category.' + filterName) }}
        </div>

        <div class="card-block">
            <date-range-slider :min="min"
                               :max="max"
                               :start="startValue"
                               :end="endValue">
            </date-range-slider>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            min: { type: Number, required: true },
            max: { type: Number, required: true },
            start: { type: Number, required: true },
            end: { type: Number, required: true },
            filterName: { type: String, required: true },
            selectedFilters: { type: Array, required: true },
            referrerUrl: { type: String, required: true },
            showHeading: { type: Boolean, required: false, default: true }
        },

        data() {
            return {
                startValue: this.start,
                endValue: this.end
            }
        },

        created() {
            EventDispatcher.listen('dateRangeValueChanged', (dateRange) => {
                if (dateRange.status == 'changed') {
                    // remove the selected date range filter parameters from the referrer url
                    var url = this.referrerUrl.replace('&selectedFilters' + encodeURI('[period][0]=') + encodeURIComponent('[' + this.start + ',' + this.end + ']'), '');

                    // append the selected date range filter parameters to the referrer url
                    url = url + '&selectedFilters' + encodeURI('[period][0]=') + encodeURIComponent('[' + dateRange.start + ',' + dateRange.end + ']');

                    // redirect to the modified url
                    window.location = url;
                }
            });
        },

        methods: {
            isAppliedFilter(filterData) {
                for (var index = 0; index < this.selectedFilters.length; index++) {
                    // retain matching and empty (i.e. [not specified]) filter selections
                    if(this.selectedFilters[index] == null || filterData['key'] == this.selectedFilters[index]) {
                        return true;
                    }
                }
                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        background:transparent;
        border:0;
        .card-header { 
            color: #333;
            font-size: 0.875rem;
            border-bottom: 1px dotted #333;
            padding: 0 0 0.25rem 0;
            margin-bottom: 0.125rem;
            background:transparent;
        }
        label {
            color: #333;
        }
        a.filter-show-more {
            font-size: 0.9rem;
            cursor: pointer;
            color: #333;
        }
    }
</style>
